import { HttpValidationProblemDetails } from '@/generated/data.schemas';

export function isHttpValidationProblemDetails(obj: unknown): obj is HttpValidationProblemDetails {
	return (obj as HttpValidationProblemDetails).errors !== undefined;
}
